import { PresentDeviceUserFilters, PresentDeviceUserService } from '@/app/platform/platform-data/services/types';
import { Injectable } from '@angular/core';
import { AsyncResult } from '@common/result/asyncResult';
import { ErrorInformation } from '@shared/models/error/error-information';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';
import { ok } from '@common/result/Result';
import { PlatformUserPresenceService } from '@data/_generated-api/platform-api/services/platform-user-presence.service';
import { UpamErrorMapper } from '@data/_generated-api/error-mappers/upam-error-mapper';
import Morphism from 'morphism';

@Injectable({
  providedIn: 'root'
})
export class PresentDeviceUserApiFacade implements PresentDeviceUserService {
  constructor(
    private readonly upamUserPresenceService: PlatformUserPresenceService,
    private readonly errorMapper: UpamErrorMapper
  ) {}

  async getAll(
    filter: PresentDeviceUserFilters
  ): AsyncResult<PresentUserData[], ErrorInformation> {
    const result = await this.upamUserPresenceService
      .postUserpresenceQueryCustomdatasource({
        body: {
          forUserGroups: filter.userGroupIds,
          onlyUsersInMyUserGroups: true
        }
      })
      .toPromise();

    if (!result.isValid) {
      return this.errorMapper.mapInvalidResult(result.errors);
    }

    const presentDeviceUsers = Morphism.map(PresentUserData, result.value.items);
    return ok(presentDeviceUsers);
  }

  async forceInvalidate(userId: string): AsyncResult<boolean, ErrorInformation> {
    const result = await this.upamUserPresenceService
      .postUserpresenceActionForceinvalidateuser({ body: { userAccountId: userId } })
      .toPromise();
    if (!result.isValid) {
      return this.errorMapper.mapInvalidResult(result.errors);
    }

    return ok(true);
  }

  async forceInvalidateAll(): AsyncResult<boolean, ErrorInformation> {
    const result = await this.upamUserPresenceService
      .postUserpresenceActionForceinvalidateallusers()
      .toPromise();
    if (!result.isValid) {
      return this.errorMapper.mapInvalidResult(result.errors);
    }

    return ok(true);
  }

  async forceStop(userId: string): AsyncResult<boolean, ErrorInformation> {
    const result = await this.upamUserPresenceService
      .postUserpresenceActionForcestopuser({ body: { userAccountId: userId } })
      .toPromise();
    if (!result.isValid) {
      return this.errorMapper.mapInvalidResult(result.errors);
    }

    return ok(true);
  }

  async forceStopAll(): AsyncResult<boolean, ErrorInformation> {
    const result = await this.upamUserPresenceService
      .postUserpresenceActionForcestopallusers()
      .toPromise();
    if (!result.isValid) {
      return this.errorMapper.mapInvalidResult(result.errors);
    }

    return ok(true);
  }
}
